import type { PageTypeResult } from 'src/hooks/usePageType'

import { dispatchAmplitudeEvent } from './dispatchAmplitudeEvent'
import { getStandardObject } from './getStandardObject'

export const sendNudgetInstallmentBarEvent = ({
  pageData,
  missingAmount,
  installmentTier,
}: {
  pageData: PageTypeResult
  missingAmount: number
  installmentTier: number
}) => {
  dispatchAmplitudeEvent({
    eventName: 'Nudget Installment Bar',
    eventData: {
      ...getStandardObject(pageData),
      'missing amount': missingAmount,
      'installment tier': installmentTier,
    },
  })
}
